import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import { ref, onMounted, onUnmounted } from '../../../../../adapter-vue';
import { TUIStore, StoreName } from '@tencentcloud/chat-uikit-engine';
import ConvertContent from './convert-content.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    message: {
      default: () => ({})
    }
  },
  setup(__props) {
    var props = __props;
    var convertVisible = ref(false);
    var hasConvertError = ref(false);
    var convertWrapperRef = ref();
    var isSingleConvert = true;
    onMounted(() => {
      TUIStore.watch(StoreName.CHAT, {
        voiceToTextInfo: onMessageConvertUpdated
      });
    });
    onUnmounted(() => {
      TUIStore.unwatch(StoreName.CHAT, {
        voiceToTextInfo: onMessageConvertUpdated
      });
    });
    function toggleErrorStatus(hasError) {
      hasConvertError.value = hasError;
    }
    function onMessageConvertUpdated(info) {
      if (info === undefined) return;
      isSingleConvert = false;
      var convertInfoList = info.get(props.message.conversationID) || [];
      for (var i = 0; i < convertInfoList.length; ++i) {
        var {
          messageID,
          visible
        } = convertInfoList[i];
        if (messageID === props.message.ID && visible !== undefined) {
          if (convertInfoList.length === 1 && visible) {
            isSingleConvert = true;
          }
          hasConvertError.value = false;
          convertVisible.value = visible;
          break;
        }
      }
    }
    return (_ctx, _cache) => {
      return _unref(convertVisible) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref_key: "convertWrapperRef",
        ref: convertWrapperRef,
        class: _normalizeClass({
          'message-convert': true,
          'reverse': props.message.flow === 'out',
          'error': _unref(hasConvertError)
        })
      }, [_createVNode(ConvertContent, {
        message: props.message,
        contentVisible: _unref(convertVisible),
        isSingleConvert: _unref(isSingleConvert),
        convertWrapperRef: _unref(convertWrapperRef),
        onToggleErrorStatus: toggleErrorStatus
      }, null, 8, ["message", "contentVisible", "isSingleConvert", "convertWrapperRef"])], 2)) : _createCommentVNode("", true);
    };
  }
});